import { Outlet } from "react-router-dom"

export default function Statistics() {
    return (<Outlet />)
}